interface TimeSlotPickerProps {
  selectedTime: string;
  onSelect: (time: string) => void;
}

const timeSlots = {
  morning: {
    label: '上午',
    icon: 'ri-sun-line',
    slots: ['09:00', '09:30', '10:00', '10:30', '11:00', '11:30'],
  },
  afternoon: {
    label: '下午',
    icon: 'ri-sun-foggy-line',
    slots: ['13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00'],
  },
};

export default function TimeSlotPicker({ selectedTime, onSelect }: TimeSlotPickerProps) {
  return (
    <div className="w-full space-y-5">
      {Object.values(timeSlots).map((period) => (
        <div key={period.label}>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-7 h-7 rounded-full bg-[#1B3D2A]/10 flex items-center justify-center">
              <i className={`${period.icon} text-sm text-[#1B3D2A]`} />
            </div>
            <span className="text-sm font-bold text-[#1B3D2A]">{period.label}</span>
          </div>
          <div className="flex flex-wrap gap-2">
            {period.slots.map((slot) => {
              const selected = selectedTime === slot;
              return (
                <button
                  key={slot}
                  type="button"
                  onClick={() => onSelect(slot)}
                  className={`px-3.5 py-2 min-h-[44px] rounded-lg text-sm font-medium transition-all duration-200 border
                    ${selected
                      ? 'bg-[#1B3D2A] text-white border-[#1B3D2A]'
                      : 'bg-white text-[#1B3D2A] border-[#E8E0D6] hover:border-[#D4A574]/50 hover:bg-[#FAF8F5]'
                    }`}
                >
                  {slot}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}